import { render } from "./ProductCategory.vue?vue&type=template&id=669dcbd9&scoped=true"
import script from "./ProductCategory.vue?vue&type=script&lang=ts"
export * from "./ProductCategory.vue?vue&type=script&lang=ts"

import "./ProductCategory.vue?vue&type=style&index=0&id=669dcbd9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-669dcbd9"

export default script